import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { VerifyEmailService } from '../../verify-email/services/verify-email.service';

const enum TodoSliceEnum {
    COMPLETE = "Complete",
    INCOMPLETE = "Incomplete"
}

class RequiredDocuments {
    id: number
    folderDocumentID: number
    documentID: number
    documentName: string
    collateral: string
    fileName: string
    fileData: any
    customerID: string
    customerName: string
    applicationId: string
    isAdditionalDocuments: boolean
    isDeleted: boolean
    isNew: boolean
}


@Component({
    selector: 'app-uploadrequireddocuments',
    templateUrl: './uploadrequireddocuments.component.html',
    styleUrls: ['./uploadrequireddocuments.component.css']
})
export class UploadRequiredDocumentsComponent implements OnInit {
    fileName: string;
    isUploaded: boolean = false;
    isSubmitted: boolean = false;
    showErrorMessages: boolean = false;
    fileUploadFailed: boolean = false;
    fileUploadFailedMessage: string;
    base64: string | ArrayBuffer;
    displayedColumns: string[] = ['id', 'documentName', 'collateral', 'fileName', 'actions']
    displayedAdditionalDocumentsColumns: string[] = ['id', 'documentName', 'fileName', 'actions']
    dataSource: MatTableDataSource<RequiredDocuments>;
    partyName: string;
    additionalDocumntsDataSource: MatTableDataSource<RequiredDocuments>;
    isValidLink: boolean = false;
    validLinkMessage: any = '';
    linkGuid: any = '';
    constructor(private router: Router, private activatedRoute: ActivatedRoute,
        private verifyEmailService: VerifyEmailService) {
        this.activatedRoute.params.subscribe((params) => {
            let id = params['id'];
            this.verifyEmailService.passwordValidationLink(id).subscribe(res => {
                this.linkGuid = id;
                if (res && res.data) {
                    this.isValidLink = res.data.errorCode == 1 ? true : false;
                    this.validLinkMessage = res.data.msg;
                    if (this.isValidLink === true) {
                        this.GetRequiredDocuments(id);
                    }
                }
            });
        });

    }

    ngOnInit() {

    }
    GetRequiredDocuments(linkGuid) {
        this.verifyEmailService.getRequiredDocuments(linkGuid).subscribe(res => {
            if (res && res.data) {
                // this.isUploaded = res.data.filter(item=>item.isAdditionalDocuments !== true && item.fileData === null).length == 0 ? true:false;
                this.partyName = res.data[0].customerName;
                this.dataSource = new MatTableDataSource(res.data.filter(item => item.isAdditionalDocuments !== true));
                this.additionalDocumntsDataSource = new MatTableDataSource(res.data.filter(item => item.isAdditionalDocuments === true));
            }

        });
    }
    saveRequiredDocuments(requiredocumentsData: RequiredDocuments[]) {
        this.verifyEmailService.postRequiredDocuments(requiredocumentsData).subscribe(res => {
            if (res && res.data) {
                this.dataSource = new MatTableDataSource(res.data);
            }
        });
    }
    async onChangeFileUpload(evt, currentSection): Promise<void> {
        let name = null;
        name = evt.target.files[0].name;
        let documentName = '';
        let documentType = '';
        let documentContent: any;

        if (name !== null && name !== undefined) {
            documentName = name.substr(0, name.lastIndexOf('.'));
            currentSection.fileName = name;
            documentType = name.substr(name.lastIndexOf('.') + 1);
        }
        if (evt.target.files.length > 0) {
            var pdffile: File = evt.target.files[0];
        }
        let byteArray = this.fileToByteArray(evt, currentSection);


    }
    async onChange(evt, currentSection): Promise<void> {
        let name = null;
        name = evt.target.files[0].name;
        const input = evt.target as HTMLInputElement;
        let documentName = '';
        let documentType = '';
        let documentContent: any;
        this.fileUploadFailed = false;
        this.fileUploadFailedMessage = null;


        if (evt.target.files[0].type !== 'application/pdf') {
            this.fileUploadFailed = true;
            this.fileUploadFailedMessage = 'Only PDF files are allowed.';
            input.value = '';
        }

        if (name !== null && name !== undefined && name.length > 50) {
            this.fileUploadFailed = true;
            this.fileUploadFailedMessage = 'File name length excedded';
            input.value = '';
        }

        if (evt.target.files.length > 0) {
            var pdffile: File = evt.target.files[0];
            let filesize = evt.target.files[0].size / 1024 / 1024;
            if (filesize >= 10) {
                currentSection.fileName = null;
                this.fileUploadFailed = true;
                this.fileUploadFailedMessage = 'File size exceeded';
                input.value = '';
            }

        }
        if (this.fileUploadFailed)
            return;

        if (name !== null && name !== undefined && name.length <= 50) {
            documentName = name.substr(0, name.lastIndexOf('.'));
            currentSection.fileName = name;
            documentType = name.substr(name.lastIndexOf('.') + 1);
        }
        let byteArray = this.fileToByteArray(evt, currentSection);


    }
    fileToByteArray(event, currentSection) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            // return Uint8Array.from(window.atob(reader.result.toString().replace(/-/g, "+").replace(/_/g, "/")), (v) => v.charCodeAt(0));
            var byteString = atob(reader.result.toString().split(',')[1]);

            var mimeString = reader.result.toString().split(',')[0].split(':')[1].split(';')[0]

            var ab = new ArrayBuffer(byteString.length);
            let ia = new Uint8Array(ab);
            for (var i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            currentSection.fileData = Array.from(ia);
        };
    }
    submitFiles() {
        this.showErrorMessages = false;
        if (this.additionalDocumntsDataSource.filteredData.length > 0) {
            this.additionalDocumntsDataSource.filteredData.forEach(item => {
                if (!(item.documentName !== null && item.documentName.trim() !== "")) {
                    this.showErrorMessages = true;
                }

            });
        }
        if (!this.showErrorMessages) {
            if (this.additionalDocumntsDataSource.data.length > 0) {
                this.additionalDocumntsDataSource.data.forEach(item => {
                    if (item.isNew) {
                        item.id = 0;
                        this.dataSource.data.push(item);
                    }
                });
            }
            this.verifyEmailService.postRequiredDocuments(this.dataSource.data).subscribe(res => {
                if (res.status === true) {
                    this.isSubmitted = true;
                    this.GetRequiredDocuments(this.linkGuid);
                }
                else {
                    this.fileUploadFailed = true;
                    this.fileUploadFailedMessage = "Uploaded files are not submitted due to internal server error!!"
                }
            });
        }
    }
    remove(row) {
        row.fileData = null;
        row.fileName = null;
    }
    removeLineItem(row) {
        let removeItemIndex = this.additionalDocumntsDataSource.data.findIndex(x => x.id == row.id);
        let items = this.additionalDocumntsDataSource.data;
        if (removeItemIndex > -1) {
            items.splice(removeItemIndex, 1);
        }
        this.additionalDocumntsDataSource.data = items;
    }
    addRow() {
        let customerId = this.dataSource.data[0].customerID;
        let customerName = this.dataSource.data[0].customerName;
        let applicationId = this.dataSource.data[0].applicationId;
        this.additionalDocumntsDataSource.data.push({
            id: this.additionalDocumntsDataSource.data.length + 1,
            folderDocumentID: 0,
            documentID: 0,
            documentName: null,
            collateral: null,
            fileName: null,
            fileData: null,
            customerID: customerId,
            customerName: customerName,
            applicationId: applicationId,
            isAdditionalDocuments: true,
            isDeleted: false,
            isNew: true
        });
        this.additionalDocumntsDataSource.filter = "";
    }
    documentNameChange(e, row) {
        row.documentName = e.target.value;
    }

    IsSubmitEnabled() {
        let isSubmitEnabled = true;
        if (this.dataSource) {
            this.dataSource.data.forEach(item => {
                if (!(item.fileData)) {
                    isSubmitEnabled = false;
                }
            });
            return isSubmitEnabled;
        } else {
            return true;
        }

    }
}
